document.addEventListener('DOMContentLoaded', function() {
	var addToWishlistButtons = document.querySelectorAll('#add-to-wishlist');
  
	addToWishlistButtons.forEach(function(button) {
	  button.addEventListener('click', function() {
		var productId = this.getAttribute('data-product-id');
		updateWishlist(productId);
	  });
	});
  });
  
  function updateWishlist(productId) {
	fetch('/account', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json',
		'X-Requested-With': 'XMLHttpRequest'
	  },
	  body: JSON.stringify({
		method: 'update_wishlist',
		product_id: productId
	  })
	}).then(response => response.json())
	  .then(data => {
		if (data.status === 'success') {
		  alert('Item added to wishlist');
		} else {
		  alert('Error adding item to wishlist');
		}
	  });
  }
  